/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import _ from "lodash";
import React from "react";

// import "react-accessible-accordion/dist/fancy-example.css";

interface ShortSurveyRankingComponentProps {
  questionType: string;
  questionValue: string;
  questionTitle: string;
  optionList: any;
  optionsListWithAnswer: any;
  disableAllAnswers: boolean;
  handleInputChange?: (
    questionType: string,
    questionValue: string,
    questionTitle: string,
    answer: any,
    isNeedState?: any
  ) => void;
}

interface ShortSuveryRankingComponentState {
  listOfOptions: any;
  optionsListWithAnswer: any;
}
class ShortSuveryRankingComponent extends React.Component<
  ShortSurveyRankingComponentProps,
  ShortSuveryRankingComponentState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      listOfOptions: [],
      optionsListWithAnswer: [],
    };
  }

  componentDidMount = () => {
    const { optionsListWithAnswer, optionList } = this.props;
    let data = optionList;

    data.forEach(function (item: { isChecked: boolean }) {
      item.isChecked = false;
    });
    if (
      optionsListWithAnswer !== undefined &&
      optionsListWithAnswer?.length > 0
    ) {
      let selected = _.find(
        data,
        (obj) => obj.id === this.props.optionsListWithAnswer?.[0]?.id
      );
      let index = _.findIndex(data, this.props.optionsListWithAnswer?.[0]);
      selected.isChecked = true;
      data.splice(index, 1, selected);
      this.setState({
        listOfOptions: data,
      });
    } else {
      data.forEach(function (item: { isChecked: boolean }) {
        item.isChecked = false;
      });
      this.setState({
        listOfOptions: data,
      });
    }
  };

  componentDidUpdate = () => {
    if (
      this.props.optionsListWithAnswer !== undefined &&
      this.state.optionsListWithAnswer !== this.props.optionsListWithAnswer
    ) {
      this.setState({
        optionsListWithAnswer: this.props.optionsListWithAnswer,
      });
      const { optionsListWithAnswer, optionList } = this.props;
      let data = optionList;

      data.forEach(function (item: { isChecked: boolean }) {
        item.isChecked = false;
      });
      if (
        optionsListWithAnswer !== undefined &&
        optionsListWithAnswer?.length > 0
      ) {
        let selected = _.find(
          data,
          (obj) => obj.id === this.props.optionsListWithAnswer?.[0]?.id
        );
        let index = _.findIndex(data, this.props.optionsListWithAnswer?.[0]);
        selected.isChecked = true;
        data.splice(index, 1, selected);
        this.setState({
          listOfOptions: data,
        });
      } else {
        data.forEach(function (item: { isChecked: boolean }) {
          item.isChecked = false;
        });
        this.setState({
          listOfOptions: data,
        });
      }
    }
  };

  handleRadioButtonChange = (id: string, value: string, index: number) => {
    const { questionValue, questionTitle, questionType } = this.props;
    const { listOfOptions } = this.state;
    let selectedValuesArray: any = [];
    let data: any = listOfOptions;
    data.forEach((item: any) => {
      if (item?.value === value) {
        item.isChecked = true;
        selectedValuesArray.push({ id: id, value: item.value });
      } else {
        item.isChecked = false;
      }
    });
    this.setState({
      listOfOptions: data,
    });
    if (this.props.handleInputChange) {
      this.props.handleInputChange(
        questionType,
        questionValue,
        questionTitle,
        selectedValuesArray,
        true
      );
    }
  };

  render() {
    const { listOfOptions } = this.state;
    const { questionValue, disableAllAnswers } = this.props;
    let metaDataStorage: any = localStorage.getItem("meta_result");
    let parsedMetaDataStorage: any = JSON.parse(metaDataStorage);
    let data: any = parsedMetaDataStorage?.data;

    return (
      <div
        className={
          disableAllAnswers ? "answers-wrapper disabled" : "answers-wrapper"
        }
      >
        <div className="options-area">
          {listOfOptions &&
            listOfOptions.length > 0 &&
            listOfOptions.map((option: any, index: number) => (
              <div className="option" onClick={() =>
                this.handleRadioButtonChange(
                  option.id,
                  option.value,
                  index
                )
              }>
                <div className="radio-btn">
                  <input
                    type="radio"
                    id={option?.id}
                    checked={option && option.isChecked}
                    value={option.value || ""}
                    name={questionValue}
                    onChange={() =>
                      this.handleRadioButtonChange(
                        option.id,
                        option.value,
                        index
                      )
                    }
                  />
                  <span className="checkmark" />
                </div>
                <div className="option-label">{option?.value}</div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default ShortSuveryRankingComponent;
